export const useFullLocale = () => {
  const { locale, locales } = useI18n();

  return computed(() => {
    const current = locale.value; // e.g. "fr"
    const match = locales.value.find((l) => l.code === current);
    return match?.language ?? current;
  });
};
